<template>
  <div class="form-item-container">
    <div class="text-container">
      <div class="text-primary-language">
        {{ text_label_lang1 }}
      </div>
      <div class="text-secondary-language" v-if="bilingue">
        {{ text_label_lang2 }}
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'TextLabel',
  props: {
    text_label_lang1: {
      type: String,
      default: ''
    },
    text_label_lang2: {
      type: String,
      default: ''
    },
    bilingue: {
      type: Boolean,
      default: false
    }
  }
})
</script>

<style scoped>
.form-item-container {

  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto;

  align-items: center;
  justify-items: center;

  padding: 2em 5% 0em 5%;

  color: white;

  .text-container {

    padding-bottom: 2em;

    .text-primary-language {
      grid-row: 1;
      /* font-size: 3em; */
      font-size: clamp(1.5em, 1vw + 1rem, 2em);
      font-weight: bold;
      padding-bottom: 0.2em;
      text-align: center;
    }

    .text-secondary-language {
      grid-row: 2;
      /* font-size: 1.5em; */
      font-size: clamp(1em, 0.5vw + 1rem, 1.5em);
      text-align: center;
    }
  }

}
</style>
